module.exports = function($){
  $.FW   = false;
  $.path = $.core;
  return $;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.fw.js
 ** module id = 115
 ** module chunks = 0
 **/